import React from 'react';

import styled from '@emotion/styled';
import Category from '../../atoms/lineupDetail/category';
import { text } from '../../../_style';

const Container = styled.div`
  margin: -10px 0 30px -10px;
  display: flex;
  flex-wrap: wrap;
  font-size: 0;
  * + & {
    padding-top: 17px;
    margin-top: 20px;
  }
`;
export default class CategoryGroup extends React.Component {
  render() {
    return (
      <Container>
        {this.props.categories.map((item, index) => (
          <Category key={index}>{item}</Category>
        ))}
      </Container>
    );
  }
}
